import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getName } from 'helpers/fieldsHelpers';

import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import { CompanyWebPages } from './CompanyWebPages';
import { CompanyContacts } from './CompanyContacts';

export default class CompanyGeneral extends Component {
    static propTypes = {
        company: PropTypes.object.isRequired
    };

    render() {
        const { company: { name, altnames, address, contacts, webpage } } = this.props;
        const companyName = getName(name);
        const companyAltName = getName(altnames);

        return (
            <div>
                <DefinitionHeader translate="common.general" iconType="info-outline" />
                <div className="panel-view">
                    <DefinitionField translate="company.companyName" text={ companyName } />
                    <DefinitionField translate="company.companyAltName" text={ companyAltName } />
                    <CompanyContacts translate="company.contacts" contacts={ contacts } />
                    <CompanyWebPages webs={ webpage } />
                    <DefinitionField translate="company.address" text={ address } />
                </div>
            </div>
        );
    }
}
